export default __webpack_public_path__ + "static/media/yachting_in_the_norwegian_fjords.4c56fe33.webp";